import { Flex, Icon, Text } from '@chakra-ui/react';
import { FaRegComment } from '@react-icons/all-files/fa/FaRegComment';

type OfferNoteProps = {
  note: string | null | undefined;
  marginTop: string;
};

const OfferNote = ({ note, marginTop }: OfferNoteProps) => {
  const trimmedNote = note?.trim();
  if (trimmedNote == null || trimmedNote === '') return null;

  return (
    <Flex gap="7px" mt={marginTop}>
      <Icon as={FaRegComment} boxSize="13px" color="grayDisabledText" mt="2px" flexShrink={0} />
      <Text fontSize="12.5px" color="gray.600" whiteSpace="pre-wrap" wordBreak="break-word">
        {trimmedNote}
      </Text>
    </Flex>
  );
};

export default OfferNote;
